import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const segment = defineConnector({
  identifier: "segment",
  name: "Segment",
  tagLine: "Customer data platform",
  keywords:
    "cdp twilio customer data platform sources destinations tracking events",
  logo,
  protocol: "http",
  tags: ["data", "observability"],
  defaultUrlPattern: () => "https://api\\.segmentapis\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your Segment API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Segment Workspace Settings](https://app.segment.com/goto-my-workspace/settings/access-management/tokens) and create a new **Public API** token.\n\nGrant it the appropriate permissions for your use case.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "Access token",
          placeholder: "Your Segment access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.segmentapis.com/",
  },
});
